import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['useInvoiceAddressAsDeliveryAddress']

  connect() {
    this.toggleAdditionalOptionsForDeliveryMethod()
    this.toggleDeliveryAddressFieldsVisibility(this.useInvoiceAddressAsDeliveryAddressTarget.checked)
  }

  toggleAdditionalOptionsForDeliveryMethod () {
    this.emailAttachPdf.hide()
    this.eInvoiceReference.hide()
    if (this.emailSelected || this.emailAndSmsSelected) {
      this.emailAttachPdf.show()
    } else if (this.eInvoiceSelected) {
      this.eInvoiceReference.show()
    }
  }

  toggleEInvoiceOption () {
    this.isPrivate ? this.hideEInvoiceOption() : this.showEInvoiceOption()
  }

  hideEInvoiceOption () {
    this.eInvoiceDeliveryMethodInput.hide()
    this.eInvoiceDeliveryMethodLabel.hide()
    if (this.eInvoiceSelected) {
      this.eInvoiceWasChecked = true
      this.emailDeliveryMethodOption.checked = true
    } else {
      this.eInvoiceWasChecked = false
    }
    this.toggleAdditionalOptionsForDeliveryMethod()
  }

  showEInvoiceOption () {
    this.eInvoiceDeliveryMethodInput.show()
    this.eInvoiceDeliveryMethodLabel.show()
    if (this.eInvoiceWasChecked) {
      this.eInvoiceDeliveryMethodOption.checked = true
    }
    this.toggleAdditionalOptionsForDeliveryMethod()
  }

  setAddressTabToInvoicing() {
    // used to make sure that the address invoice tab is shown, when changing org number
    this.changeTab(document.getElementById('link-tab-invoice-address'))
  }

  changeTab(tabHeaderElement) {
    // do nothing if click is same as active tab
    var deliveryTab = this.getDeliveryAddressTab()
    var invoiceTab = this.getInvoiceAddressTab()
    var activeTab = deliveryTab.classList.contains('hidden') ? invoiceTab : deliveryTab
    if (tabHeaderElement.id == 'link-tab-delivery-address') {
      if (activeTab == deliveryTab) {
        return
      }
    } else if (tabHeaderElement.id == 'link-tab-invoice-address') {
      if (activeTab == invoiceTab) {
        return
      }
    }
    // change style for tabs
    Array.from(tabHeaderElement.parentElement.parentElement.children).forEach( tabHeader => this.toggleActiveClass(tabHeader))
    this.getDeliveryAddressTab().classList.toggle('hidden')
    this.getInvoiceAddressTab().classList.toggle('hidden')
  }

  toggleActiveClass(element) {
    if (element.classList.contains('active')) {
      element.classList.remove('active')
    } else {
      element.classList.add('active')
    }
  }

  changeTabByClick(e) {
    this.changeTab(e.target)
  }

  toggleDeliveryAddressFieldsVisibility(checked) {
    if (checked) {
      if (!this.deliveryAddressFields.classList.contains('hidden')) {
        this.deliveryAddressFields.classList.add('hidden')
      }
    }
    else {
      if (this.deliveryAddressFields.classList.contains('hidden')) {
        this.deliveryAddressFields.classList.remove('hidden')
      }
    }
  }

  clickToggleDeliveryAddressFieldsVisibility(e) {
    this.toggleDeliveryAddressFieldsVisibility(e.target.checked)
  }

  getTabsMainElement() {
    return document.getElementById('address-tabs')
  }

  getDeliveryAddressTab() {
    return this.getTabsMainElement().getElementById('tab-delivery-address')
  }

  getInvoiceAddressTab() {
    return this.getTabsMainElement().getElementById('tab-invoice-address')
  }

  get deliveryAddressFields () {
    return $('delivery_address_fields')
  }

  get isPrivate () {
    return $('client_client_type_individual').checked
  }

  get eInvoiceSelected () {
    return $('client_settings_invoice_delivery_method_e_invoice').checked
  }

  get emailSelected () {
    return $('client_settings_invoice_delivery_method_email').checked
  }

  get emailAndSmsSelected () {
    return $('client_settings_invoice_delivery_method_email_and_sms').checked
  }

  get eInvoiceReference () {
    return $('e-invoice-reference')
  }

  get emailAttachPdf () {
    return $('setting-document_attach_pdf')
  }

  get eInvoiceDeliveryMethodInput () {
    return $('client_settings_invoice_delivery_method_e_invoice')
  }

  get eInvoiceDeliveryMethodLabel () {
    return $$('label[for=client_settings_invoice_delivery_method_e_invoice]')[0]
  }

  get eInvoiceDeliveryMethodOption () {
    return $('client_settings_invoice_delivery_method_e_invoice')
  }

  get emailDeliveryMethodOption () {
    return $('client_settings_invoice_delivery_method_email')
  }
}
